import React from "react"

export default function TypeConditionalNumber({ value, description }) {
  return <div>{value} </div>
}
